import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import { accountService, alertService } from '../../_services';

import moment from 'moment';

function EditReservation({ history, match }) {
  const { id } = match.params;
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [submittingRefund, setSubmittingRefund] = useState(false);
  const [init, setInit] = useState({
    startDate: '',
    accountEmail: '',
    area: '',
    created: '',
    isRefunded: ''
  });

  useEffect(() => {
    async function fetchData() {
      const init = await accountService.getReservationById(id);
      console.log(init);
      setInit(init);
    }
    fetchData();
  }, []);

  const lockerAreas = accountService.configValue['lockerAreas'].split(";");
  const minRentalDate = accountService.configValue['minRentalDate'];
  const maxRentalDate = accountService.configValue['maxRentalDate'];
  const createdDate = init.created.split(".")[0].replace("T", " ");

  //TODO fixme min_date and max_date are copypasta from main reservation.jsx
  function min_date() {
    switch (minRentalDate) {
      case "TODAY":
        return moment().format("YYYY-MM-DD");
        break;
      case "TOMORROW":
        var tomorrow = moment().add(1, 'days');
        return moment(tomorrow).format("YYYY-MM-DD");
        break;
      default:
        return moment(minRentalDate).format("YYYY-MM-DD");
    }
  }

  function max_date() {
    if (moment(maxRentalDate, "YYYY-MM-DD", true).isValid()) {
      return moment(maxRentalDate).format("YYYY-MM-DD");
    } else {
      return moment().add(parseInt(maxRentalDate), 'days').format("YYYY-MM-DD");
    }
  }


  const validationSchema = Yup.object().shape({

  });

    function onSubmit(fields, { setStatus, setSubmitting }) {
        setStatus();
        updateReservation(id, fields, setSubmitting);
    }
    function refundReservation(id) {
        let confirmed = window.confirm('Are you sure?');
        console.log(confirmed);
        if (confirmed) {
            setSubmittingRefund(true);
            accountService.refundReservation(id)
                .then(() => { setSubmittingRefund(false); alertService.success('Reservation refunded!') })
                .catch(error => { setSubmittingRefund(false); alertService.error(error) });
        }
    }

  const handleDateChange = (e) => {
    setDate(e.target.value);
  }; 




  function updateReservation(id, fields, setSubmitting) {
    accountService.updateReservation(id, fields)
      .then(() => {
        alertService.success('Update Reservation successful', { keepAfterRouteChange: true });
        history.push('..');
      })
      .catch(error => {
        setSubmitting(false);
        alertService.error(error);
      });
  }

  return (
    <Formik enableReinitialize={true} initialValues={init} validationSchema={validationSchema} onSubmit={onSubmit}>
      {({ errors, touched, isSubmitting, handleChange }) => {
        return (
          <Form>
            <div className="card-header header-admin">
              <h2 className="bold-tx">Editing Reservation:{id}</h2>
              <h2> {init.accountEmail} </h2>
              <h2> Date: {init.startDate} </h2>
              <h2> Area: {init.area} </h2>
              <h2> Created: {createdDate} </h2>
            </div>

            <div className="form-group col-6">
              <label>Edit Area</label>
              <Field as="select"
                name="area"
                onChange={(e) => { handleChange(e);  }}
                className={'form-control' + (errors.area && touched.area ? ' is-invalid' : '')} >
                <option key={'default'} value={""}>Select Area . . .</option>
                {
                  lockerAreas.map((val) =>
                    <option key={val} value={val}> {val}</option>
                  )
                }
              </Field>
              <ErrorMessage name="area" component="div" className="invalid-feedback" />
            </div>

            <div className="form-row">
              <div className="form-group col-6">
                <label>Edit Date</label>
                <Field
                  onChange={(e) => { handleChange(e); handleDateChange(e, this); }}
                  name="startDate" max={max_date()} min={min_date()} type="date" className={'form-control' + (errors.startDate && touched.startDate ? ' is-invalid' : '')} />
                <ErrorMessage name="startDate" component="div" className="invalid-feedback" />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">

                <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                  {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                  Update Reservation
                </button>

                <br/>
                  {!init.isRefunded &&
                    <button onClick={() => refundReservation(init.id)} className="btn btn-danger " disabled={submittingRefund}>
                      {submittingRefund
                        ? <span className="spinner-border spinner-border-sm"></span>
                        : <span>Refund Reservation</span>
                      }
                    </button>
                  }


                <Link to={`/admin/reservations`} className="btn btn-link">Cancel</Link>
              </div>
            </div>


          </Form>
        );
      }}
    </Formik>
  );
}

export { EditReservation };
